export const my = {
  extends: 'ContentPage',
  metadata: (el) => ({ title: el.call('pageTitle', 'workspace.my.page.title') }),
  // `eyebrow` is a CUSTOM prop, so a function value is auto-invoked (Rule 70)
  // and ContentPage's `el.parent.parent.parent.parent.eyebrow` reads the
  // resolved string.
  //
  // There is NO `title:` prop any more — same reasoning as
  // packages/shared/pages/profile.js: `title` is a global HTML attribute that
  // ContentPage read as CONTENT (docs/I18N-CONVENTION.md §1.2, the one case
  // with no working rewrite form). The page overrides ContentPage's Title
  // SLOT below instead, and drops the stray native tooltip with the prop.
  eyebrow: (el) => el.call('polyglot', 'account.profile.eyebrow'),
  // `sectionKey` is the SCROLL KEY: ContentPageSectionLink matches it against
  // `[data-content-section="<key>"]` in MemberProfile.js and writes it to
  // `root.contentSection`. It stays the English string those attributes
  // already carry and must NEVER be translated — a translated key breaks the
  // scroll on the first switch. `label` is the VISIBLE string and goes
  // through polyglot in the FUNCTION form; this factory runs inside
  // ContentPage's reactive `children` factory, so the rail re-renders on a
  // language switch. Same contract as packages/shared/pages/profile.js, and
  // the keys are shared with it.
  //
  // The rail lists exactly the cards the page shows, in the page's reading
  // order. It listed Availability while the owner's card was hidden and
  // missed Accessibility and Assistant, which the page showed (live
  // 2026-10-28). Since member-profile stage 3 the list is ONE shared function
  // (memberProfileAccess.js memberProfileSections) that this page and the
  // shared /profile and /settings page ask: /my is the profile view, so its
  // rail lists the profile's cards.
  sections: (el, s) => el.call('memberProfileSections', s),

  // Content mounts in ContentPage's main column (PageMain.Body) — the
  // notes-page skeleton; see components/ContentPage.js.
  PageMain: {
    // The heading. FUNCTION form, matching profile.js — the account path is
    // held to one form by components/LanguageSelectField.test.js.
    Header: {
      LeftGroup: {
        // One title per host (design-direction.md §3): "My profile" is the
        // pane bar word for word, so it yields under one. The eyebrow stays.
        Title: {
          hide: (el, s) => el.call('paneTitleBarShown', s),
          text: (el) => el.call('polyglot', 'account.my.title')
        }
      }
    },
    Body: {
      PageBody: {
        flow: 'y',
        flex: '1',
        minWidth: '0',
        MemberProfile: {}
      }
    }
  }
}
